import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { appRoutesUrls } from 'constants/appRoutesUrls';
import { dashboardService } from 'services/dashboardService';
import { apiUrls } from 'constants/apiUrls';
import ProgressLoader from 'components/Loader/ProgressLoader';
import { BsFillCartPlusFill, BsFillPeopleFill } from 'react-icons/bs';

const Dashboard = () => {
    const [dashboardDetails, setDashboardDetails] = useState();
    const [isLoader, setIsLoader] = useState(false);

    useEffect(() => {
        setIsLoader(true);
        dashboardService.getDashboardDetails(apiUrls.getDashboardDetails()).then((res) => {
            setIsLoader(false);
            setDashboardDetails(res);
        }).catch((err) => setIsLoader(false));
    }, []);

    return (
        <>
            {isLoader && <ProgressLoader />}
            <Row>
                <Col md={4}>
                    <Card className="card-stats card-primary" as={Link} to={appRoutesUrls.users()}>
                        <Card.Body>
                            <Row>
                                <Col md={4}>
                                    <div className="icon-big text-center">
                                        <BsFillPeopleFill size={48} />
                                    </div>
                                </Col>
                                <Col md={8} className="col-stats">
                                    <div className="text-center">
                                        <strong className="card-category">Users</strong>
                                        <h4 className="card-title">{dashboardDetails?.users}</h4>
                                    </div>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="card-stats card-info" as={Link} to={appRoutesUrls.customers()}>
                        <Card.Body>
                            <Row>
                                <Col md={4}>
                                    <div className="icon-big text-center">
                                        <BsFillPeopleFill size={48} />
                                    </div>
                                </Col>
                                <Col md={8} className="col-stats">
                                    <div className="text-center">
                                        <strong className="card-category">Customers</strong>
                                        <h4 className="card-title">{dashboardDetails?.customers}</h4>
                                    </div>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="card-stats card-secondary" as={Link} to={appRoutesUrls.invoices()}>
                        <Card.Body>
                            <Row>
                                <Col md={4}>
                                    <div className="icon-big text-center">
                                        <BsFillCartPlusFill size={48} />
                                    </div>
                                </Col>
                                <Col md={8} className="col-stats">
                                    <div className="text-center">
                                        <strong className="card-category">Invoices</strong>
                                        <h4 className="card-title">{dashboardDetails?.invoices}</h4>
                                    </div>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default Dashboard;